// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLoggedInUser } from '../../../contexts/UserProvider';
import { blacklistUsers, BlacklistUsersRequest } from '../../../utils/operationalApi';

const useBlacklistUsers = () => {
  const { userAccessToken } = useLoggedInUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['blacklistUsers'],
    mutationFn: (request: BlacklistUsersRequest) => blacklistUsers(userAccessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blacklistedUsers'] });
    },
  });
};

export default useBlacklistUsers;
